// extracted by mini-css-extract-plugin
export var carrierIcon = "_v1-0";
export var carrierLogo = "_v1-1";
export var detailsSection = "_v1-2";